const sparkline = (
  c: HTMLCanvasElement,
  data: number[],
  endpoint: boolean,
  color = 'rgba(0, 0, 0, 0.5)',
  style: 'line' | 'bar' = 'line',
) => {
  const ctx = c.getContext('2d');
  const height = c.height - 3;
  const { width } = c;
  const total = data.length;
  const max = Math.max(...data);
  const xstep = width / (total - 1);
  const ystep = max / height;

  let x = 0;
  let y = height - data[0] / ystep;
  let i;

  if (ctx) {
    ctx.clearRect(0, 0, c.width, c.height);
    ctx.beginPath();
    ctx.strokeStyle = color;
    ctx.lineWidth = 1.5;
    ctx.moveTo(x, y);

    for (i = 1; i < total; i += 1) {
      if (data[i] !== null) {
        x += xstep;
        y = height - data[i] / ystep + 2;
        if (style === 'bar') {
          ctx.moveTo(x, height);
        }
        ctx.lineTo(x, y);
      }
    }

    ctx.stroke();

    if (endpoint && style === 'line') {
      ctx.beginPath();
      ctx.fillStyle = 'rgba(255,0,0,0.5)';
      ctx.arc(x, y, 1.5, 0, Math.PI * 2);
      ctx.fill();
    }
  }
};

export default sparkline;
